<template>
  <div>
    <app-header />
    <!-- S : page 타이틀 -->
    <mpn-page-title :title="pageTitle" />
    <!-- E : page 타이틀 -->

    <!-- S : main -->
    <main
      id="survey_content"
      class="a-service-main"
    >
      <!-- S : 컨텐츠 영역 -->
      <div class="a-service-container">
        <div class="cont_section">
          <div class="gray_box">
            <p>설문을 통해 뉴트리라이트가 제안하는 추천팩을<br><span>확인하고 손쉽게 신청하세요.</span></p>

            <!-- S : 카테고리 체크 -->
            <survey-category-check @choice-category="selectCategory" />
            <!-- E : 카테고리 체크 -->
          </div>
          <!-- S : 설문 내용 -->
          <survey-survey-contents
            v-model="btnShowRecommendationEnabled"
            :selected-category="selectedCategory"
            @positive-check-count-changed="onPositiveCheckCountChanged"
          />
        <!-- E : 설문 내용 -->
        </div>
        <div class="btn_group type2">
          <div>
            <!-- <button
              type="button"
              class="btn_default-a medium"
              :disabled="!btnShowRecommendationEnabled"
              @click="showRecommendPack"
            >
              추천팩 보기
            </button> -->
            <mpn-basic-button
              :disabled="!btnShowRecommendationEnabled"
              @click="showRecommendPack"
            >
              추천팩 보기
            </mpn-basic-button>
          </div>
        </div>
        <!-- S : 추천팩 목록 -->
        <survey-recommendation-section
          v-show="appearanceRecommendPack"
          ref="recommendationsection"
          :searched-recommendation-pack="searchedRecommendationPack"
          @selected="onRecommendationSelected"
        />
        <!-- E : 추천팩 목록 -->
        <!-- S : 조합/신청 버튼 -->
        <main-button-group
          v-if="appearanceRecommendPack"
          :disabled-left="disabledMainBtnGroup"
          :disabled-right="disabledMainBtnGroup"
          title-left="조합수정"
          title-right="바로신청"
          @click-left="onRecomposition"
          @click-right="onApply"
        />
      </div>
      <!-- E : 조합/신청 버튼 -->
      <!-- E : 컨텐츠 영역 -->

      <!-- S : 플로팅 버튼 -->
      <floating-button-group
        v-if="appearanceRecommendPack"
        title-left="조합수정"
        title-right="바로신청"
        :disabled-left="disabledMainBtnGroup"
        :disabled-right="disabledMainBtnGroup"

        @click-left="onRecomposition"
        @click-right="onApply"
      />

      <!-- E : 플로팅 버튼-->
      <modal-alert
        ref="refModalAlert"
      />
    </main>
    <app-footer />
  </div>
</template>

<script>
import { CONTEXT_TYPE } from '@/utils/constants';
import { mapGetters } from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import MainButtonGroup from '@/components/MainButtonGroup.vue';
import FloatingButtonGroup from '@/components/FloatingButtonGroup.vue';
import { log } from '@/utils/common';
import compositionHelpers from '@/utils/helpers/composition';

import ModalAlert from '@/components/global/ModalAlert.vue';
import SurveySurveyContents from './partial/SurveySurveyContents.vue';
import SurveyRecommendationSection from './partial/SurveyRecommendationSection.vue';
import SurveyCategoryCheck from './partial/SurveyCategoryCheck.vue';

export default {
  name: 'Survey',
  components: {
    AppHeader,
    AppFooter,
    SurveyCategoryCheck,
    SurveySurveyContents,
    SurveyRecommendationSection,
    FloatingButtonGroup,
    MainButtonGroup,
    ModalAlert,
  },
  data() {
    return {
      pageTitle: '건강 설문 후 추천받기',
      selectedCategory: '',
      btnShowRecommendationEnabled: false,
      positiveCheckCount: -1,
      appearanceRecommendPack: false,
      selectedPackCd: null,
      searchedRecommendationPack: [],
    };
  },
  computed: {
    ...mapGetters({
      recommendationPacks: 'recommendation/recommendations',
      surveyContents: 'survey/surveyContents',
    }),
    disabledMainBtnGroup() {
      if (this.selectedPackCd !== null) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.$store.dispatch('survey/init');
  },
  methods: {
    selectCategory(value) {
      this.selectedCategory = value;
      this.appearanceRecommendPack = false;
    },
    showRecommendPack() {
      if (this.positiveCheckCount === 0) {
        const packArr = [];
        packArr.push(...this.recommendationPacks.filter((n2) => n2.pack_category_cd === 'PC11'));
        this.searchedRecommendationPack = packArr;
      } else {
        const recmPacksCode = this.surveyContents[this.selectedCategory].recmPacks;
        const yesPack = [];
        recmPacksCode.forEach((n) => {
          yesPack.push(...this.recommendationPacks.filter((n2) => n2.pack_cd === n));
        });
        this.searchedRecommendationPack = yesPack;
      }
      this.appearanceRecommendPack = true;
      this.selectedPackCd = null;
      setTimeout(() => {
        this.$refs.recommendationsection.resetSelection();
      });
    },
    onPositiveCheckCountChanged(cnt) {
      this.positiveCheckCount = cnt;
    },
    onRecommendationSelected(packCd) {
      this.selectedPackCd = packCd;
    },

    async onRecomposition() {
      // 주문서 생성 제한 해제
      // if (!await compositionHelpers.checkMypackLimit(this.$refs.refModalAlert)) {
      //   return;
      // }
      compositionHelpers.doRecompositionFromRecommendationPack(
        this.$store,
        this.recommendationPacks,
        this.selectedPackCd,
      );
      this.$router.push(`/agreement/${CONTEXT_TYPE.RECOMPOSITION}`);
    },
    async onApply() {
      // 주문서 생성 제한 해제
      // if (!await compositionHelpers.checkMypackLimit(this.$refs.refModalAlert)) {
      //   return;
      // }
      log('Survey::onApply', `apply with ${this.selectedPackCd}`);

      compositionHelpers.doCompositionFinalFromRecommendationPack(
        this.$store,
        this.recommendationPacks,
        this.selectedPackCd,
      );
      this.$router.push(`/agreement/${CONTEXT_TYPE.COMPOSITION_FINAL}`);
    },

  },
};
</script>
